import { useAppSelector } from "../../../../redux/hooks";
import { CooperativeProfileView } from "./cooperative/view";
import { MemberProfileView } from "./member/view";

export const ProfileView = () => {
  const { profile } = useAppSelector((state) => state.auth);

  return profile?.type === "cooperative" ? (
    <CooperativeProfileView />
  ) : (
    <MemberProfileView />
  );
};
